export default "__VITE_ASSET__DhZqMzZm__"